// extracted by mini-css-extract-plugin
module.exports = {"paymentBox":"StripePayment_paymentBox__3q31S"};